import { useCallback } from 'react';
export function useNavigationConditional(options) {
  const {
    condition,
    onConditionMet,
    onConditionNotMet
  } = options;
  return useCallback(async function () {
    if (condition) {
      await onConditionMet(...arguments);
    } else {
      await onConditionNotMet(...arguments);
    }
  }, [condition, onConditionMet, onConditionNotMet]);
}
//# sourceMappingURL=useNavigationConditional.js.map